import { useEffect, useState } from "react";
import newRequest from "../../../../utils/newRequest";
import DataTable from "../../../../components/userAdminPanel/Components/UserDataTable/DataTable";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import Swal from "sweetalert2";
import { useTranslation } from "react-i18next";
import { languageDataColumn } from "../../../../datatablesource";
import CustomSnakebar from "../../../../utils/CustomSnakebar";
import AddLanguage from "./AddLanguage";
import UpdateLanguage from "./UpdateLanguage";

const Language = () => {
  const { t, i18n } = useTranslation();
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState([]);
  const [message, setMessage] = useState(null);
  const [error, setError] = useState(null);
  const [isCreatePopupVisible, setCreatePopupVisibility] = useState(false);
  const [isUpdatePopupVisible, setUpdatePopupVisibility] = useState(false);
  const [filteredData, setFilteredData] = useState([]);

  const handleShowCreatePopup = () => {
    setCreatePopupVisibility(true);
  };

  const handleShowUpdatePopup = (row) => {
    setUpdatePopupVisibility(true);
    sessionStorage.setItem("updateLanguageSection", JSON.stringify(row));
  };

  const refreshData = async () => {
    try {
      const response = await newRequest.get("/getAllLanguages");
      setData(response?.data || []);
    } catch (err) {
      setError(err?.response?.data?.error || err?.message || "Failed to load");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    refreshData();
  }, []);

  const handleDelete = async (row) => {
    Swal.fire({
      title: `${t("Are you sure to delete this record?")}!`,
      text: `${t("You will not be able to recover this")} ${t("Language")}!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: `${t("Yes")} , ${t("Delete")}!`,
      cancelButtonText: `${t("No, keep it")}!`,
      confirmButtonColor: "#1E3B8B",
      cancelButtonColor: "#FF0032",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await newRequest.delete(`/deleteLanguageById/${row?.id}`);
          setMessage(
            `${t("Language")} ${t("has been deleted")} ${t("successfully")}!`
          );
          refreshData();
        } catch (err) {
          setError(
            `${t("Language")} ${t("has been not deleted")} ${t("Delete")} ${t(
              "has been not deleted"
            )}!`
          );
        }
      }
    });
  };

  const handleRowClickInParent = (item) => {
    if (!item || item?.length === 0) {
      setFilteredData(data);
      return;
    }
  };

  const resetSnakeBarMessages = () => {
    setError(null);
    setMessage(null);
  };

  return (
    <div>
      <div className="p-0 h-full">
        {message && (
          <CustomSnakebar
            message={message}
            severity="success"
            onClose={resetSnakeBarMessages}
          />
        )}
        {error && (
          <CustomSnakebar
            message={error}
            severity="error"
            onClose={resetSnakeBarMessages}
          />
        )}
        <div className="flex justify-center items-center">
          <div className="h-auto w-[97%] px-0 pt-4">
            <div className="h-auto w-full p-0 bg-white shadow-xl rounded-md">
              <div
                className={`flex  sm:justify-start items-center flex-wrap gap-2 py-7 px-3 ${
                  i18n.language === "ar"
                    ? "flex-row-reverse justify-start"
                    : "flex-row justify-start"
                }`}
              >
                <button
                  onClick={handleShowCreatePopup}
                  className="rounded-full bg-secondary font-body px-5 py-1 text-sm mb-3 text-white transition duration-200 hover:bg-primary"
                >
                  <i className="fas fa-plus mr-2"></i>
                  {t("Add")}
                </button>
              </div>
              <div style={{ marginLeft: "-11px", marginRight: "-11px" }}>
                <DataTable
                  data={data}
                  title={t("Language")}
                  columnsName={languageDataColumn(t)}
                  loading={isLoading}
                  secondaryColor="secondary"
                  handleRowClickInParent={handleRowClickInParent}
                  dropDownOptions={[
                    {
                      label: t("Edit"),
                      icon: (
                        <EditIcon
                          fontSize="small"
                          color="action"
                          style={{ color: "rgb(37 99 235)" }}
                        />
                      ),
                      action: handleShowUpdatePopup,
                    },
                    {
                      label: t("Delete"),
                      icon: (
                        <DeleteIcon
                          fontSize="small"
                          color="action"
                          style={{ color: "rgb(37 99 235)" }}
                        />
                      ),
                      action: handleDelete,
                    },
                  ]}
                  uniqueId="languageTableId"
                />
              </div>
            </div>
          </div>
        </div>

        {isCreatePopupVisible && (
          <AddLanguage
            isVisible={isCreatePopupVisible}
            setVisibility={setCreatePopupVisibility}
            refreshData={refreshData}
            onSuccess={setMessage}
            onError={setError}
          />
        )}
        {isUpdatePopupVisible && (
          <UpdateLanguage
            isVisible={isUpdatePopupVisible}
            setVisibility={setUpdatePopupVisibility}
            refreshData={refreshData}
            onSuccess={setMessage}
            onError={setError}
          />
        )}
      </div>
    </div>
  );
};

export default Language;
